import { BroadcastChannel } from 'broadcast-channel';

interface MessageLogoutRunning {
	action: 'logout_running';
	phase: 'started' | 'ended';
}

export const channelLogoutRunning = new BroadcastChannel<MessageLogoutRunning>(
	'logout_running',
	{
		type: typeof window === 'undefined' ? 'simulate' : 'native',
		webWorkerSupport: false,
	}
);
